import { createLucideIcon } from 'lucide-react';
export const UserPenIcon = createLucideIcon('', [
  [
    'path',
    {
      d: 'M10 13C5 13.2157 5 19 5 19',
      key: '1w6pdn',
    },
  ],
  [
    'path',
    {
      d: 'M17.5 13C17.0211 13.1669 13 18 13 18V20L14.8193 19.5L19 14.5C19.4548 13.5 18.3466 12.7049 17.5 13Z',
      key: 'ygz11r',
    },
  ],
  [
    'path',
    {
      d: 'M6 9C6 6.78906 7.78906 5 10 5C12.2109 5 14 6.78906 14 9C14 11.2109 12.2109 13 10 13C7.78906 13 6 11.2109 6 9Z',
      key: 'qznew6',
    },
  ],
]);
